import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
@Component({
  selector: 'app-admin-totals-card',
  standalone: false,
  templateUrl: './admin-totals-card.html',
  styleUrl: './admin-totals-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminTotalsCard {
  readonly description = input<string>('');
  /** Active filters in words ("Ciksi · errors only"); null/empty = unfiltered. */
  readonly filterLabel = input<string | null>(null);
  /** Chip text when unfiltered, e.g. "Whole platform · Sep 17 – Oct 17". */
  readonly scopeLabel = input<string>('Whole platform');
  /** Figures per row on wide screens (2 below 900px). */
  readonly columns = input<number>(4);
  /** Dims the figures while a filter change is re-fetching them. */
  readonly loading = input<boolean>(false);
  /** First load: render a skeleton figure per label instead of projected
   *  figures, so the card doesn't pop in once the numbers arrive. */
  readonly skeletonLabels = input<string[] | null>(null);

  protected readonly skeleton = computed(() => !!this.skeletonLabels()?.length);
  protected readonly filtered = computed(() => !!this.filterLabel());
  protected readonly chipText = computed(() =>
    this.filtered() ? `Filtered · ${this.filterLabel()}` : this.scopeLabel());
}
